
const bookmarksDataLeft = [
    {
        id:"1",
        title:"Search",
        url:"",
        img:"folder",
        children: [
            {
                id:"1-1",
                title:"Google",
                url:"https://www.google.com/", 
                img:"https://www.google.com/favicon.ico",
                children:""
            },
            {
                id: "1-2",
                title: "Startpage",
                url:"https://startpage.com/",
                img:"https://startpage.com/favicon.ico",
                children:""
            },
            {
                id: "1-3",
                title: "DuckDuckGo",
                url:"https://duckduckgo.com/",
                img:"https://duckduckgo.com/favicon.ico",
                children:""
            },
        ]
    },
    {
        id:"2",
        title:"News",
        url:"",
        img:"folder",
        children: [
            {
                id:"2-1",
                title:"THN",
                url:"https://thehackernews.com/", 
                img:"https://thehackernews.com/favicon.ico",
                children:""
            },
            {
                id: "2-2",
                title: "EttremeTech",
                url:"https://www.extremetech.com/",
                img:"https://www.extremetech.com/wp-content/themes/extremetech/favicon.ico",
                children:""
            },
            {
                id: "2-3",
                title: "HaD",
                url:"https://hackaday.com/",
                img:"https://hackaday.com/favicon.ico",
                children:""
            },
            {
                id: "2-4",
                title: "Economist",
                url:"https://www.economist.com/",
                img:"https://www.economist.com/favicon.ico",
                children:""
            },
            {
                id: "2-5",
                title: "Hacker News",
                url:"https://news.ycombinator.com/",
                img:"https://news.ycombinator.com/favicon.ico",
                children:""
            },
        ]
    },
    {
        id:"3",
        title:"Tools",
        url:"",
        img:"folder",
        children: [
            {
                id:"3-1",
                title:"Tutorial",
                url:"", 
                img:"folder",
                children:[
                    {
                        id:"3-1-1",
                        title:"MIT Introduction, Financial Terms and Concepts",
                        url:"https://www.youtube.com/watch?v=wvXDB9dMdEo&list=PLUl4u3cNGP63ctJIEC1UnZ0btsphnnoHR", 
                        img:"https://www.youtube.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"3-2",
                title:"Math",
                url:"", 
                img:"folder",
                children:[
                    {
                        id:"3-2-1",
                        title:"Triangle Calculator",
                        url:"https://www.calculator.net/triangle-calculator.html", 
                        img:"https://www.calculator.net/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-2-2",
                        title: "Symbolab Math solver",
                        url:"https://www.symbolab.com/",
                        img:"https://www.symbolab.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-2-3",
                        title: "WolframAlpha Math solver",
                        url:"https://www.wolframalpha.com/",
                        img:"https://www.wolframalpha.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"3-2",
                title:"Text",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "3-2-1",
                        title: "DiffChecker",
                        url:"https://www.diffchecker.com/",
                        img:"https://www.diffchecker.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-2-2",
                        title: "CiteThisForMe citation maker",
                        url:"https://www.citethisforme.com",
                        img:"https://www.citethisforme.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-2-3",
                        title: "MyBib citation maker",
                        url:"https://www.mybib.com/",
                        img:"https://www.mybib.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-2-4",
                        title: "Word Counter",
                        url:"https://wordcounter.net/",
                        img:"https://wordcounter.net/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"3-3",
                title:"Search",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "3-3-1",
                        title: "Reddit Search",
                        url:"https://camas.github.io/reddit-search/",
                        img:"https://camas.github.io/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-3-2",
                        title: "Internet Search Tips",
                        url:"https://www.gwern.net/Search",
                        img:"https://www.gwern.net/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-3-3",
                        title: "MrKoll",
                        url:"https://mrkoll.se/",
                        img:"https://mrkoll.se//favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id: "3-5",
                title: "Terms of Service Didn't Read",
                url:"https://tosdr.org/",
                img:"https://cdn.tosdr.org/themes/crisp/favicon/apple-touch-icon.png?5e5a185deb0791ba28fde00e308f488c5845f2bcc02f3d8437f2115b20627967",
                children:""
            },
            {
                id: "3-6",
                title: "Have I been pwned",
                url:"https://haveibeenpwned.com/",
                img:"https://haveibeenpwned.com/favicon.ico",
                children:""
            },
            {
                id: "3-7",
                title: "Archive Wayback Machine",
                url:"https://archive.org/",
                img:"https://archive.org/favicon.ico",
                children:""
            },
            {
                id: "3-8",
                title: "PNG file chunk inspector",
                url:"https://www.nayuki.io/page/png-file-chunk-inspector",
                img:"https://www.nayuki.io/favicon.ico",
                children:""
            },
            {
                id: "3-9",
                title: "Maps",
                url:"",
                img:"folder",
                children:[
                    {
                        id: "3-9-1",
                        title: "Soviet map",
                        url:"",
                        img:"folder",
                        children:[
                            {
                                id: "3-9-1-1",
                                title: "Soviet Military Maps A Treasure Trove for Backpackers",
                                url:"http://www.compasscaddy.com/soviet-military-maps-a-treasure-trove-for-wilderness-backpackers/",
                                img:"http://www.compasscaddy.com/favicon.ico",
                                children:""
                            },
                            {
                                id: "3-9-1-2",
                                title: "Load Map viewer",
                                url:"http://loadmap.net/en",
                                img:"http://loadmap.net/favicon.ico",
                                children:""
                            },
                            {
                                id: "3-9-1-3",
                                title: "Homyaki Map Viewer",
                                url:"http://akosarev.info/engine/?interface=geo_maps&form=main",
                                img:"http://akosarev.info/favicon.ico",
                                children:""
                            },
                            {
                                id: "3-9-1-4",
                                title: "Vlasenko Map Viewer",
                                url:"https://maps.vlasenko.net/",
                                img:"https://maps.vlasenko.net/favicon.ico",
                                children:""
                            }, 
                        ]
                    },
                    {
                        id: "3-9-2",
                        title: "Strava Heatmap",
                        url:"https://www.strava.com/heatmap#2.75/-74.62703/32.94810/hot/all",
                        img:"https://www.strava.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-3",
                        title: "Map Maker Nat Geo",
                        url:"https://mapmaker.nationalgeographic.org/",
                        img:"https://mapmaker.nationalgeographic.org/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-4",
                        title: "Lantmäteri Karta",
                        url:"https://minkarta.lantmateriet.se/",
                        img:"https://minkarta.lantmateriet.se/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-5",
                        title: "Google Maps",
                        url:"https://www.google.com/maps/",
                        img:"https://www.google.com/maps/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-6",
                        title: "Flood Map",
                        url:"https://www.floodmap.net/",
                        img:"https://www.floodmap.net/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-7",
                        title: "Light Pollution Map",
                        url:"https://www.lightpollutionmap.info",
                        img:"https://www.lightpollutionmap.info/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-8",
                        title: "Dark Site Finder",
                        url:"https://darksitefinder.com/maps/world.html#4/54.01/22.15",
                        img:"https://darksitefinder.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-9",
                        title: "Find Star Link",
                        url:"https://findstarlink.com/",
                        img:"https://findstarlink.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-10",
                        title: "Star Link SX",
                        url:"https://starlink.sx/",
                        img:"https://starlink.sx/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-9-11",
                        title: "Submarine Cable Map 2021",
                        url:"https://submarine-cable-map-2021.telegeography.com/",
                        img:"https://submarine-cable-map-2021.telegeography.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"3-10",
                title:"Piracy",
                url:"",
                img:"folder",
                children: [
                    {
                        id: "3-10-1",
                        title: "Reddit Piracy Guide",
                        url:"https://www.reddit.com/r/Piracy/wii/index?utm_source=reddit&utm_medium=usertext&utm_name=Piracy&utm_content=t3_6583hl",
                        img:"https://www.reddit.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-10-2",
                        title: "Awesome Piracy Guide",
                        url:"https://github.com/Igglybuff/awesome-piracy/blob/master/readme.md",
                        img:"https://github.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "3-10-3",
                        title: "Sites",
                        url:"",
                        img:"folder",
                        children: [
                            {
                                id: "3-10-3-1",
                                title: "1337X",
                                url:"https://1337x.to/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-2",
                                title: "The Pirate Bay",
                                url:"https://thepiratebay.org/index.html",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-3",
                                title: "AudioBook Bay",
                                url:"http://audiobookbay.nl/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-4",
                                title: "FitGirl Repack Games",
                                url:"https://fitgirl-repacks.site/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-5",
                                title: "Z-lib",
                                url:"https://z-lib.org/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-6",
                                title: "Tokyo Book",
                                url:"https://tokybook.com/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-7",
                                title: "AudioBooks",
                                url:"https://xaudiobooks.com/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-8",
                                title: "IR games piracy group",
                                url:"http://dl.gold-team.ir/Online/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-9",
                                title: "Lime Torrents",
                                url:"https://www.limetorrents.pro/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-10",
                                title: "RARBG",
                                url:"https://rarbg.to/index80.php",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-11",
                                title: "RUtracker",
                                url:"https://rutracker.org/forum/index.php",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-12",
                                title: "Toorgle torrent search",
                                url:"https://www.toorgle.com/",
                                img:"",
                                children:""
                            },
                            {
                                id: "3-10-3-12",
                                title: "Zooqle",
                                url:"https://zooqle.com/",
                                img:"",
                                children:""
                            },
                        ]
                    },
                ]
            },
        ]
    },
    {
        id:"4",
        title:"Dev",
        url:"",
        img:"folder",
        children: [
            {
                id:"4-1",
                title:"Python",
                url:"", 
                img:"folder",
                children:[
                    {
                        id:"4-1-1",
                        title:"Python Dunder Methods",
                        url:"https://levelup.gitconnected.com/python-dunder-methods-ea98ceabad15", 
                        img:"https://levelup.gitconnected.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-1-2",
                        title: "Pynguin unit test generator",
                        url:"https://github.com/se2p/pynguin",
                        img:"https://github.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-1-3",
                        title: "Nukita python compiler",
                        url:"https://github.com/Nuitka/Nuitka",
                        img:"https://github.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-1-4",
                        title: "A Concrete Introduction to Probability (using Python)",
                        url:"https://github.com/norvig/pytudes/blob/main/ipynb/Probability.ipynb",
                        img:"https://github.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id:"4-2",
                title:"UI",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-2-1",
                        title:"Tkinter",
                        url:"", 
                        img:"folder",
                        children:[
                            {
                                id: "4-2-1-1",
                                title: "Python Tkinter course",
                                url:"https://www.youtube.com/watch?v=YXPyB4XeYLA",
                                img:"https://www.youtube.com/favicon.ico",
                                children:""
                            },
                            {
                                id: "4-2-1-2",
                                title: "TkDocs python",
                                url:"https://tkdocs.com/shipman/index-2.html",
                                img:"https://tkdocs.com/favicon.ico",
                                children:""
                            },

                        ]
                    },
                    {
                        id: "4-2-2",
                        title:"TailWind CSS",
                        url:"", 
                        img:"folder",
                        children:[
                            {
                                id: "4-2-2-1",
                                title: "TailWind with React install",
                                url:"https://tailwindcss.com/docs/guides/create-react-app",
                                img:"https://tailwindcss.com/favicon.ico",
                                children:""
                            },
                            {
                                id: "4-2-2-2",
                                title: "TailWind Cheatsheet",
                                url:"https://nerdcave.com/tailwind-cheat-sheet",
                                img:"https://nerdcave.com/favicon.ico",
                                children:""
                            },

                        ]
                    },
                    {
                        id: "4-2-3",
                        title:"CSS",
                        url:"", 
                        img:"folder",
                        children:[
                            {
                                id: "4-2-3-1",
                                title: "A Complete Guide to Flexbox ",
                                url:"https://css-tricks.com/snippets/css/a-guide-to-flexbox/",
                                img:"https://css-tricks.com/favicon.ico",
                                children:""
                            },
                            {
                                id: "4-2-3-2",
                                title: "Pure CSS inspiration OnlineTutorials",
                                url:"https://www.youtube.com/c/OnlineTutorials4Designers/videos",
                                img:"https://www.youtube.com/favicon.ico",
                                children:""
                            },
                            {
                                id: "4-2-3-3",
                                title: "Create custom scrollbars using CSS",
                                url:"https://www.youtube.com/watch?v=lvKK2fs6h4I",
                                img:"https://www.youtube.com/favicon.ico",
                                children:""
                            }

                        ]
                    },
                    {
                        id: "4-2-4",
                        title: "Dark Mode UI: the definitive guide",
                        url:"https://uxdesign.cc/dark-mode-ui-design-the-definitive-guide-part-1-color-53dcfaea5129",
                        img:"https://uxdesign.cc/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-2-5",
                        title: "MyColor.space",
                        url:"https://mycolor.space/",
                        img:"https://mycolor.space/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-2-6",
                        title: "UI Design Daily",
                        url:"https://www.uidesigndaily.com/",
                        img:"https://www.uidesigndaily.com/public/img/favicon-32x32.png",
                        children:""
                    },
                    {
                        id: "4-2-7",
                        title: "Tool.Graphics Geometric Art",
                        url:"https://tool.graphics/geometric",
                        img:"https://tool.graphics/favicon.ico",
                        children:""
                    }                    
                ]
            },
            {
                id:"4-3",
                title:"C",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-3-1",
                        title: "Learn C.org",
                        url:"https://www.learn-c.org/",
                        img:"https://www.learn-c.org/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-3-2",
                        title: "Tutorial spot C",
                        url:"https://www.tutorialspoint.com/cprogramming/index.htm",
                        img:"https://www.tutorialspoint.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-3-3",
                        title:"Programiz C",
                        url:"https://www.programiz.com/c-programming", 
                        img:"https://www.programiz.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-3-4",
                        title:"Compiler explorer",
                        url:"https://godbolt.org/", 
                        img:"https://godbolt.org/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-3-5",
                        title:"Data Structures - Full Course Using C and C++",
                        url:"https://www.youtube.com/watch?v=B31LgI4Y4DQ", 
                        img:"https://www.youtube.com/favicon.ico",
                        children:""
                    }
                ]
            },
            {
                id:"4-4",
                title:"Web-stack",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-4-1",
                        title: "UnMinify",
                        url:"https://unminify.com/",
                        img:"https://unminify.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-4-2",
                        title: "OpenMoji",
                        url:"https://openmoji.org/",
                        img:"https://openmoji.org/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-3-3",
                        title:"React Icons",
                        url:"https://react-icons.github.io/react-icons/", 
                        img:"https://react-icons.github.io/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id: "4-5",
                title:"FreeCodeCamp",
                url:"https://www.freecodecamp.org/learn/", 
                img:"https://www.freecodecamp.org/favicon.ico",
                children:""
            },
            {
                id: "4-6",
                title:"PythonTutor visualiser",
                url:"https://pythontutor.com/visualize.html#mode=edit", 
                img:"https://pythontutor.com/favicon.ico",
                children:""
            },
            {
                id:"4-7",
                title:"Practice problems",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-7-1",
                        title: "leetCode",
                        url:"https://leetcode.com/",
                        img:"https://leetcode.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-2",
                        title: "HackerRank",
                        url:"https://www.hackerrank.com/",
                        img:"https://www.hackerrank.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-3",
                        title:"Project Lovelace",
                        url:"https://projectlovelace.net/problems/", 
                        img:"https://projectlovelace.net/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-4",
                        title:"App Ideas Collection",
                        url:"https://github.com/florinpop17/app-ideas", 
                        img:"https://github.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-5",
                        title:"Binary search interview questions",
                        url:"https://binarysearch.com/", 
                        img:"https://binarysearch.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-6",
                        title:"Code Signal interview questions",
                        url:"https://codesignal.com/", 
                        img:"https://codesignal.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-7",
                        title:"Coderpad interview questions",
                        url:"https://coderpad.io/", 
                        img:"https://coderpad.io/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-7-8",
                        title:"75 most relevant leetCode questions",
                        url:"https://leetcode.com/discuss/general-discussion/460599/blind-75-leetcode-questions", 
                        img:"https://leetcode.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id: "4-8",
                title:"Computer Science from the Bottom Up",
                url:"https://www.bottomupcs.com/", 
                img:"https://www.bottomupcs.com/favicon.ico",
                children:""
            },
            {
                id: "4-9",
                title:"The memory models that underlie programming languages",
                url:"http://canonical.org/~kragen/memory-models/", 
                img:"http://canonical.org/favicon.ico",
                children:""
            },
            {
                id: "4-10",
                title:"Data Structure Visualizations",
                url:"https://www.cs.usfca.edu/~galles/visualization/Algorithms.html", 
                img:"https://www.cs.usfca.edu/~galles/visualization/favicon.ico",
                children:""
            },
            {
                id: "4-11",
                title:"Cobol",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-11-1",
                        title:"Mainframe: The Complete COBOL Course From Beginner To Expert",
                        url:"https://www.udemy.com/course/mainframe-the-complete-cobol-course-from-beginner-to-expert/", 
                        img:"https://www.udemy.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-11-1",
                        title:"GnuCOBOL compiler",
                        url:"https://sourceforge.net/projects/gnucobol/files/?%3Cbr%20/%3Esource=navbar", 
                        img:"https://sourceforge.net/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id: "4-12",
                title:"Hosting",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-11-1",
                        title:"Netlify",
                        url:"https://www.netlify.com/", 
                        img:"https://www.netlify.com/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id: "4-13",
                title:"Regex",
                url:"", 
                img:"folder",
                children:[
                    {
                        id: "4-13-1",
                        title:"Regex R",
                        url:"https://regexr.com/", 
                        img:"https://regexr.com/favicon.ico",
                        children:""
                    },
                    {
                        id: "4-13-2",
                        title:"Regex Generator",
                        url:"https://regex-generator.olafneumann.org", 
                        img:"https://regex-generator.olafneumann.org/favicon.ico",
                        children:""
                    },
                ]
            },
            {
                id: "4-14",
                title:"Sam Bowne Classes",
                url:"https://samsclass.info/", 
                img:"https://samsclass.info/favicon.ico",
                children:""
            },
            {
                id: "4-15",
                title:"GitHub",
                url:"https://github.com/", 
                img:"https://github.com/favicon.ico",
                children:""
            },
        ]
    },
    {
        id:"5",
        title:"Awesome's Big Link Tree",
        url:"https://github.com/sindresorhus/awesome/blob/main/readme.md",
        img:"https://github.com/favicon.ico",
        children:""
    },
]



export default bookmarksDataLeft;